import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AnalyticFunction = () => (
  <QPhototModuleSubtopic
    title="Analytic function"
    videos={[
      "https://www.youtube.com/embed/_8oF7L0KlgU",
      "https://www.youtube.com/embed/LeA5yx2jKlk",
      "https://www.youtube.com/embed/KlV5F1uH7Ok"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_1.png"},
        {image:"/cvla_2.png"},
        {image:"/cvla_3.png"},
        {image:"/cvla_4.png"},
    ]}
    exampleVideos={[]}
  />
);

export default AnalyticFunction;
